import { APIPaths } from '@bcm/apis';
import { StatusCodes } from 'http-status-codes';
import { BODY_SITE } from './utils/actionCases';
import { actionDefaults } from './utils/actionUtils';
import { params } from '../reducers/bodySitesReducers';
import req from './utils/req';
import { urlToB64 } from '../../src/imageUtils';

// Chrome has a caching error which displays as a "CORS" error if you display (?) a presigned URL
// So we preprocess/fetch the data here and store it.
const prefetch = async (bodySite) => {
	const bodySiteFrontB64 = await urlToB64(bodySite.bodySiteFrontSignedUrl);
	const bodySiteBackB64 = await urlToB64(bodySite.bodySiteBackSignedUrl);
	return {
		...bodySite,
		bodySiteFrontB64,
		bodySiteBackB64,
	};
};

const bodySiteActions = {
	getPage: (eocId, conditionId, query) => async (dispatch) => {
		const res = await req(APIPaths.bodySiteGetPage, {
			dispatch,
			params: {
				eocId,
				conditionId,
			},
			query,
		});
		let processedRes = { ...res };
		if(res.status === StatusCodes.OK && res.data.bodySites.length > 0) {
			const processedBodySites = [];
			for(const bodySite of res.data.bodySites) {
				processedBodySites.push(await prefetch(bodySite));
			}
			processedRes.data.bodySites = processedBodySites;
		}
		await dispatch(actionDefaults.getPage(BODY_SITE, processedRes, params));
		return res;
	},
	getOne: (eocId, conditionId, bodySiteId) => async (dispatch) => {
		const res = await req(APIPaths.bodySiteGetOne, {
			dispatch,
			params: {
				eocId,
				conditionId,
				bodySiteId,
			},
		});
		const processedRes = { ...res };
		if(res.status === StatusCodes.OK && res.data) {
			processedRes.data = await prefetch(res.data);
		}
		await dispatch(actionDefaults.getItem(BODY_SITE, processedRes, params));
		return res;
	},
	create: (eocId, conditionId,
		bodySiteFront, bodySiteBack,
		tbsaDataFront, tbsaDataBack,
		bodySitesDataFront, bodySitesDataBack,
		tbsaFormula, fluidResuscitationFormula ) => async (dispatch) => {
		const res = await req(APIPaths.bodySiteCreate, {
			dispatch,
			body: {
				tbsaDataFront,
				tbsaDataBack,
				bodySitesDataFront,
				bodySitesDataBack,
				tbsaFormula,
				fluidResuscitationFormula,
				bodySiteFront,
				bodySiteBack,
			},
			params: {
				eocId,
				conditionId,
			},
		});
		const processedRes = { ...res };
		if(res.status === StatusCodes.OK && res.data) {
			processedRes.data.bodySite = await prefetch(res.data.bodySite);
		}
		await dispatch(actionDefaults.postItem(BODY_SITE, processedRes, params));
		return res;
	},
	update: (eocId, conditionId, bodySiteId,
		bodySiteFront, bodySiteBack,
		tbsaDataFront, tbsaDataBack,
		bodySitesDataFront, bodySitesDataBack,
		tbsaFormula, fluidResuscitationFormula ) => async (dispatch) => {
		const res = await req(APIPaths.bodySiteUpdate, {
			dispatch,
			body: {
				tbsaDataFront,
				tbsaDataBack,
				bodySitesDataFront,
				bodySitesDataBack,
				tbsaFormula,
				fluidResuscitationFormula,
				bodySiteFront,
				bodySiteBack,
			},
			params: {
				eocId,
				conditionId,
				bodySiteId,
			},
		});
		const processedRes = { ...res };
		if(res.status === StatusCodes.OK && res.data) {
			processedRes.data.bodySite = await prefetch(res.data.bodySite);
		}
		await dispatch(actionDefaults.putItem(BODY_SITE, processedRes, params));
		return res;
	},
	delete: (eocId, conditionId, bodySiteId) => async (dispatch) => {
		const res = await req(APIPaths.bodySiteDelete, {
			dispatch,
			params: {
				eocId,
				conditionId,
				bodySiteId,
			},
		});
		await dispatch(actionDefaults.deleteItem(BODY_SITE, res, params));
		return res;
	},

	setActive: (bodySiteId) => async (dispatch) => await dispatch(actionDefaults.setActive(BODY_SITE, bodySiteId, params)),
};
export default bodySiteActions;